<template>
  <div class="min-h-screen bg-[#0f172a] overflow-x-hidden">

    <button
      type="button"
      data-mdb-ripple="true"
      data-mdb-ripple-color="light"
      @click="backToTop"
      class="inline-block z-10 p-3 hover:scale-105 transition-all  bg-yellow-400 text-white font-medium text-xs leading-tight uppercase rounded-full shadow-md hover: bg-yellow-400 hover:shadow-lg focus: bg-yellow-400  focus:shadow-lg focus:outline-none focus:ring-0 active: bg-yellow-400  active:shadow-lg transition duration-150 ease-in-out bottom-5 right-5"
      id="btn-back-to-top"
    >
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        class="w-4 h-4"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
      >
        <path
          fill="currentColor"
          d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
        ></path>
      </svg>
    </button>


    <!-- ================= NAVBAR ================= -->
    <Popover
      :class="[
        'fixed w-full top-0 left-0 z-50 transition-all duration-300',
        scrolled
          ? 'bg-[#0f172a] backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      ]"
    >
      <div class="max-w-7xl mx-auto px-4 sm:px-6">
        <div class="flex items-center justify-between py-4">

          <!-- Logo -->
          <router-link to="/" class="flex items-center gap-2">
            <img class="h-9 w-auto" src="../assets/logo11.png" alt="oillead" />
            <div class="leading-tight">
              <div class="text-sm font-extrabold text-white">
                OIL<span class="text-yellow-400">L</span>EAD
              </div>
              <div class="text-xs font-bold tracking-wide text-yellow-400">
                SERVICES
              </div>
            </div>
          </router-link>

          <!-- Desktop Nav -->
          <PopoverGroup class="hidden lg:flex items-center gap-10">
            <router-link to="/" class="nav-link">HOME</router-link>
            <router-link to="/about" class="nav-link">ABOUT US</router-link>
            <router-link to="/services"  class="nav-link">SERVICES</router-link>
            <router-link to="/projects"  class="nav-link">PROJECTS</router-link>
            <router-link to="/contact"  class="nav-link">CONTACT US</router-link>
          </PopoverGroup>

          <!-- Mobile Button -->
          <div class="lg:hidden">
            <PopoverButton
              class="rounded-md p-2 text-white hover:bg-white/10 transition"
            >
              ☰
            </PopoverButton>
          </div>
        </div>
      </div>

      <!-- ================= MOBILE MENU ================= -->
      <transition
        enter-active-class="duration-200 ease-out"
        enter-from-class="opacity-0 scale-95"
        enter-to-class="opacity-100 scale-100"
        leave-active-class="duration-150 ease-in"
        leave-from-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-95"
      >
        <PopoverPanel
          v-slot="{ close }"
          focus
          class="absolute z-50 top-0 inset-x-0 p-4 transform origin-top-right lg:hidden"
        >
          <div class="rounded-2xl shadow-2xl
                      bg-[#0f172a]/95 backdrop-blur-xl
                      border border-white/10">

            <div class="flex items-center justify-between px-6 py-5 border-b border-white/10">


                <div class="text-sm flex gap-2 font-bold text-white" >
                  <PopoverButton
                    class="flex items-center outline-none ring-0 focus:outline-none focus:ring-0 active:ring-0 border-0"
                    >
                    <img class="h-8 w-auto sm:h-10" src="../assets/logo11.png" alt="" />
                    </PopoverButton>
                   <div class="leading-tight">
                        <div class="text-sm font-extrabold text-white">
                            OIL<span class="text-yellow-400">L</span>EAD
                        </div>
                        <div class="text-xs font-bold tracking-wide text-yellow-400">
                            SERVICES
                        </div>
                    </div>
                </div>


              

              <PopoverButton
                class="rounded-md p-2 text-white hover:bg-white/10 transition"
              >
                ✕
              </PopoverButton>
            </div>

             <div class="px-6 py-6 flex flex-col items-center text-center gap-6">
                <router-link to="/" class="nav-link" @click="close">HOME</router-link>
                <router-link to="/about" class="nav-link" @click="close">ABOUT US</router-link>
                <router-link to="/services" class="nav-link" @click="close">SERVICES</router-link>
                <router-link to="/projects" class="nav-link" @click="close">PROJECTS</router-link>
                <router-link to="/contact" class="nav-link" @click="close">CONTACT US</router-link>
            </div>
          </div>
        </PopoverPanel>
      </transition>
    </Popover>


    <main class="pt-32">

      <!-- ================= ABOUT HERO ================= -->
      <section class="relative py-10 bg-[#0f172a] overflow-hidden">
        <div class="absolute inset-0 -z-10 bg-gradient-to-br from-[#facc15]/10 via-transparent to-transparent"></div>

        <div class="max-w-7xl mx-auto px-6">
          <div class="grid lg:grid-cols-2 gap-16 items-center">

            <!-- TEXT -->
            <div>
              <span class="text-xs tracking-[0.3em] font-bold text-[#facc15]">
                ABOUT OILLEAD SERVICES
              </span>

              <h1 class="mt-6 text-4xl sm:text-5xl font-extrabold text-white leading-tight">
                Engineering Excellence<br />
                Across Africa & Beyond
              </h1>

              <p class="mt-8 text-lg leading-8 text-gray-300">
                Oillead Integrated Services Ventures Limited (OLS) is a multi-disciplinary EPCI company delivering complex offshore
                and onshore engineering solutions. Our expertise spans Engineering
                Design, Procurement, Construction, Installation, and Asset Integrity
                Management — ensuring safe, efficient, and cost-effective execution.
              </p>
            </div>

            <!-- IMAGE -->
            <div class="relative h-[420px] rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="../assets/ourprojects1.png"
                alt="Engineering Project"
                class="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
              />
              <div class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              <div class="absolute inset-0 ring-1 ring-[#facc15]/30"></div>
            </div>

          </div>
        </div>
      </section>

      <!-- ================= MISSION & VISION ================= -->
      <section class="py-32 bg-[#0f172a]">
        <div class="max-w-7xl mx-auto px-6">
          <div class="grid lg:grid-cols-2 gap-12">

            <!-- Mission -->
            <div class="rounded-3xl bg-slate-900/70 p-10 border border-slate-700/60">
              <h3 class="text-xs tracking-[0.3em] font-bold text-[#facc15]">
                OUR MISSION
              </h3>

              <p class="mt-6 text-xl leading-8 text-gray-200">
                To provide high quality services driven by research, innovation, responsiveness 
                and commitment to customer satisfaction based on highly trained, competent and 
                disciplined workforce using cutting-edge technology to deliver world class engineering 
                services for our discerning clients.
              </p>

               <!-- Vision 
              <p class="mt-6 text-gray-400 leading-7">
                Leveraging a disciplined workforce and cutting-edge technology to
                provide world-class engineering solutions that meet global standards. 
              </p> -->
            </div>

            <!-- Vision -->
            <div class="rounded-3xl bg-slate-900/70 p-10 border border-slate-700/60">
              <h3 class="text-xs tracking-[0.3em] font-bold text-[#facc15]">
                OUR VISION
              </h3>

              <p class="mt-6 text-xl leading-8 text-gray-200">
                To become Nigeria’s leading servicing company with multinational
                capabilities and expertise in :
              </p>

              <ul class="mt-6 space-y-3 text-gray-400">
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  Engineering Design
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  Construction Services
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  Project Management
                </li>
                <li class="flex gap-3">
                  <span class="h-2 w-2 mt-2 rounded-full bg-[#facc15] flex-shrink-0"></span>
                  Material Procurement within the Oil and Gas industry
                </li>
              </ul>
            </div>

          </div>
        </div>
      </section>

      <!-- ================= CLIENTS ================= -->
      <section class="py-32 bg-[#0f172a] relative overflow-hidden">
        <div class="absolute inset-0 -z-10 bg-gradient-to-br from-[#facc15]/5 via-transparent to-transparent"></div>

        <div class="max-w-7xl mx-auto px-6">

          <div>
            <span class="text-xs tracking-[0.35em] font-semibold text-yellow-400">
             PARTNERSHIPS
            </span>
            <h2 class="mt-6 text-3xl sm:text-4xl font-extrabold text-white">
              Clients & Strategic Partnerships
            </h2>

            <p class="mt-6 text-lg text-gray-300">
              OLS collaborates with top-tier operators, EPC contractors, and
              industrial enterprises across Africa and internationally.
            </p>
          </div>

          <div class="mt-16 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8">
            <div
              v-for="(client, index) in clients"
              :key="index"
              class="flex items-center justify-center rounded-2xl
                     bg-white p-5 shadow-md ring-1 ring-black/5
                     hover:shadow-xl transition"
            >
              <img
                :src="client.src"
                :alt="client.alt"
                class="max-h-12 object-contain"
              />
            </div>
          </div>

        </div>
      </section>

        <!-- ================= CTA ================= -->
    <section id="contact" class="relative py-28 bg-[#0f172a]">
    

      <div class="max-w-2xl mx-auto text-center px-6">
        <h2 class="text-4xl font-bold text-white mb-6">
          Ready to Transform Your Project?
        </h2>
        <p class="text-xl text-gray-300 mb-10">
      Let's discuss how OLS can deliver engineering excellence for your next challenge.
        </p>

        <router-link to="/contact"
          class="inline-flex items-center gap-2 bg-yellow-400 font-bold py-4 px-10 rounded-xl text-black shadow-lg hover:bg-yellow-400 hover:scale-105 transition-all">
          Get in Touch →
        </router-link>
      </div>
    </section>
                     
                  
        <!-- ================= FOOTER ================= -->
    <footer class="bg-[#0f172a] border-t border-slate-800 py-10 text-center text-gray-400">
      © 2026 OILLEAD SERVICES. All rights reserved.
    </footer>

    </main>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue"
import { Popover, PopoverButton, PopoverGroup, PopoverPanel } from "@headlessui/vue"

import exxon from "../assets/ourclients_exxonmobil.png"
import crestech from "../assets/ourclients_crestech.png"
import oceon from "../assets/ourclients_oceon.png"
import utiebe from "../assets/utiebe.png"
import netco from "../assets/ourclients_NETCO.png"
import nnpc from "../assets/ourclients_NNPC.png"
import bua from "../assets/ourclients_BUA.png"
import npd from "../assets/ourclients_NPD.png"
import amazon from "../assets/ourclients_amazonenergy.png"
import panocean from "../assets/ourclients_panocean.png"
import total from "../assets/ourclients_Total.png"


/* ================= NAVBAR SCROLL ================= */

const scrolled = ref(false)

const handleScroll = () => {
  scrolled.value = window.scrollY > 50
}

   // your arrow scroll function
      function scrollFunction() {
      if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        let mybutton = document.getElementById("btn-back-to-top");
        if (mybutton) mybutton.style.display = "block";
      } else {
        let mybutton = document.getElementById("btn-back-to-top");
        if (mybutton) mybutton.style.display = "none";
      }
    }

    // your arrow scroll function
    function backToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      })
    }

onMounted(() => {
      // navabar scroll
      window.addEventListener("scroll", handleScroll);

      // your arrow onscroll
      window.onscroll = function () {
        scrollFunction();
      };
    });

    onUnmounted(() => {
      //navbar scroll
      window.removeEventListener("scroll", handleScroll);

      // cleanup arrow scroll
      window.onscroll = null;
    });


/* ================= CLIENTS ================= */

const clients = [
  { src: exxon, alt: "ExxonMobil" },
  { src: crestech, alt: "Crestech" },
  { src: oceon, alt: "Oceon" },
  { src: utiebe, alt: "Utiebe" },
  { src: netco, alt: "NETCO" },
  { src: nnpc, alt: "NNPC" },
  { src: bua, alt: "BUA" },
  { src: npd, alt: "NPD" },
  { src: amazon, alt: "Amazon Energy" },
  { src: panocean, alt: "PanOcean" },
  { src: total, alt: "TotalEnergies" },
]
</script>

<style scoped>
.nav-link {
  font-size: 0.875rem;        /* text-sm */
  font-weight: 600;           /* font-semibold */
  letter-spacing: 0.05em;     /* tracking-wide */
  color: #ffffff;             /* text-white */
  cursor: pointer;            /* cursor-pointer */
  transition-property: color; /* transition-colors */
  transition-duration: 150ms;
  transition-timing-function: ease-in-out;
}

.nav-link:hover {
  color: #facc15; /* hover:text-yellow-400 */
}
</style>